import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id E990CF7B-A7D8-444E-99FE-24930ABF2FA6
 * name arrow-left-bold
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-bold.svg
 * tags
 * - Arrow 
 * - Automotive 
 */
export const ArrowLeftBoldIcon = createSvgIcon(<><path d="M20,9V15H12V19.84L4.16,12L12,4.16V9H20Z" /></>, 'ArrowLeftBoldIcon');
export default ArrowLeftBoldIcon